const each = (value, transform) => value != null ? Array.from(value, transform) : [];

export { each };
